import AppContainer from "../AppContainer";
import DaoLocator from "./DaoLocator";
import NotificationDispatcher from "../notification-dispatcher/NotificationDispatcher";
import getOffer from "../../action/getOffer";
import acceptOrRejectMediumAvailability from "../../action/acceptOrRejectMediumAvailability";
import copyTextToClipboard from "../../action/copyTextToClipboard";
import notify from "../../action/notify";
import updateManyAvailabilities from "../../action/updateManyAvailabilities";
import getMediumFilterOptions from "../../action/getMediumFilterOptions";
import getOfferMediums from "../../action/getOfferMediums";
import updateOffer from "../../action/updateOffer";
import ApiClient from "../../infrastructure/api/ApiClient";
import getAllMediumIds from "../../action/getAllMediumIds";


export default class ActionsLocator {
    private readonly appContainer: AppContainer;
    private readonly daosLocator: DaoLocator;
    private readonly api: ApiClient;
    private readonly notificationDispatcher: NotificationDispatcher;
    private readonly instances: { [name: string | number]: any } = {};

    constructor(appContainer: AppContainer) {
        this.appContainer = appContainer;
        this.daosLocator = appContainer.getDaosLocator();
        this.notificationDispatcher = appContainer.getNotificationDispatcher();
        this.api = appContainer.getApiClient();
    }

    public copyTextToClipboard = () => this.get('copyTextToClipboard', () => copyTextToClipboard(this.notificationDispatcher));
    public getOffer = () => this.get('getOffer', () => getOffer(this.appContainer.getDaosLocator().offers()));
    // public uploadFile = () => this.get('uploadFile', () => uploadFile(this.daosLocator.files()));
    public getMediumFilterOptions = () => this.get('getMediumFilterOptions', () => getMediumFilterOptions(this.daosLocator.offers()));
    public acceptOrRejectMediumAvailability = () => this.get('acceptOrRejectMediumAvailability', () => acceptOrRejectMediumAvailability(this.daosLocator.mediumAvailabilities(), this.notificationDispatcher));
    public notify = () => this.get('notify', () => notify(this.notificationDispatcher));
    public updateManyAvailabilities = () => this.get('updateManyAvailabilities', () => updateManyAvailabilities(this.api, this.notificationDispatcher));
    public getOfferMediums = () => this.get('getOfferMediums', () => getOfferMediums(this.appContainer.getDaosLocator().offerMediums()));
    public updateOffer = () => this.get('updateOffer', () => updateOffer(this.api, this.notificationDispatcher));
    public getAllMediumIds = () => this.get('getAllMediumIds', () => getAllMediumIds(this.appContainer.getDaosLocator().offerMediums()));

    private readonly get = <T extends object>(name: string, factory: () => T): T => {
        if (!this.instances[name]) {
            this.instances[name] = factory();
        }
        return this.instances[name] as T;
    };
}